export default "__VITE_ASSET__1cf1ccc6__"